/**
 * @desc 通过SupplierCode供应商编号获取供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getDetailByCode`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
